import { create } from 'zustand';

type Theme = 'light' | 'dark' | 'system';

interface ThemeState {
  theme: Theme;
  resolved: 'light' | 'dark';
  init: () => void;
  setTheme: (t: Theme) => void;
  toggle: () => void;
}

function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyTheme(dark: boolean) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (dark) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: 'system',
  resolved: 'light',

  init: () => {
    const stored = (localStorage.getItem('theme') as Theme) || 'system';
    const resolved = stored === 'system' ? getSystemTheme() : stored;
    set({ theme: stored, resolved });
    applyTheme(resolved === 'dark');

    // Lytt til system-endringer hvis theme er 'system'
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (get().theme === 'system') {
        const r = e.matches ? 'dark' : 'light';
        set({ resolved: r });
        applyTheme(e.matches);
      }
    });
  },

  setTheme: (t: Theme) => {
    localStorage.setItem('theme', t);
    const resolved = t === 'system' ? getSystemTheme() : t;
    set({ theme: t, resolved });
    applyTheme(resolved === 'dark');
  },

  toggle: () => {
    const current = get().resolved;
    const next = current === 'dark' ? 'light' : 'dark';
    get().setTheme(next);
  },
}));
